import { VLNoActionModal } from "views/uikit/VLModal";
import styles from "./style.module.scss";
import VLImagesCarouselPreview, {
  ImageObj,
  ImagesCarouselPagination,
} from "views/uikit/VLCarousel/VLImagesCarouselPreview";
import { Option } from "views/uikit/FormFields/SelectList";
import { useState } from "react";
import ReviewModalHeader from "./ReviewModalHeader";
import ReviewModalClassesList from "./ReviewModalClassesList";

interface ReviewModalProps {
  open?: boolean;
  onClose: () => void;
  labelsOptions: Option[];
  initialSelectedItem?: number;
  imagesList: (ImageObj & { labelId?: string; id: string })[];
  selectedLabel?: string;
  onCheckBoxClick?: (item: {
    labelId: string;
    sampleId: string;
  }) => Promise<void>;
  counters?: { total: number; forReview: number };
  /** for a paginated images list: no wrap around, more images loaded near the end */
  pagination?: ImagesCarouselPagination;
}

export default function ReviewModal({
  imagesList,
  open = false,
  onClose,
  initialSelectedItem,
  labelsOptions,
  selectedLabel,
  onCheckBoxClick,
  counters,
  pagination,
}: ReviewModalProps) {
  const [selectedItem, setSelectedItem] = useState(initialSelectedItem);
  const selected =
    selectedItem !== undefined ? imagesList[selectedItem] : undefined;

  return (
    <VLNoActionModal
      variant="general"
      isOpen={open}
      onClose={onClose}
      size="large"
    >
      <ReviewModalHeader counters={counters} selectedLabel={selectedLabel} />
      <div className={styles.wrapper}>
        <div className={styles.carouselWrapper}>
          <VLImagesCarouselPreview
            imagesList={imagesList}
            selectedItem={selectedItem}
            afterChange={(e) => setSelectedItem(e)}
            pagination={pagination}
          />
        </div>
        <ReviewModalClassesList
          labelsOptions={labelsOptions}
          selected={selected}
          onCheckBoxClick={async (e) => {
            if (!onCheckBoxClick) return;
            await onCheckBoxClick(e);
          }}
          counters={counters}
          className={styles.list}
        />
      </div>
    </VLNoActionModal>
  );
}
